<template>
  <div class="tg-deposit" v-if="visible">
    <div class="body">
      <van-field v-model="amount" type="number" label="金额" :placeholder="amountPlaceholder" />
      <van-radio-group v-model="channelKey" class="methods">
        <van-radio
          v-for="ch in channels"
          :key="channelKeyFor(ch)"
          :name="channelKeyFor(ch)"
        >
          {{ ch.name || ch.code }}
        </van-radio>
      </van-radio-group>
      <p v-if="selectedChannel && selectedChannel.remark" class="hint">{{ selectedChannel.remark }}</p>
      <van-button type="primary" block :loading="loading" @click="submit">立即充值</van-button>
      <p class="hint small">支付完成后余额自动到账，无需人工审核</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tgDeposit',
  props: { visible: { type: Boolean, default: false } },
  data() {
    return {
      amount: '',
      channelKey: '',
      channels: [],
      loading: false,
    };
  },
  computed: {
    amountPlaceholder() {
      const ch = this.selectedChannel;
      if (ch && (ch.type === 'usdt_auto' || ch.amount_unit === 'usdt')) {
        const min = ch.min_price != null ? ch.min_price : 10;
        return 'USDT 数量，最低 ' + min;
      }
      if (ch && ch.min_price != null) {
        return '最低 ' + ch.min_price;
      }
      return '最低 10';
    },
    selectedChannel() {
      const that = this;
      if (!that.channelKey || !that.channels.length) {
        return null;
      }
      for (let i = 0; i < that.channels.length; i++) {
        if (that.channelKeyFor(that.channels[i]) === that.channelKey) {
          return that.channels[i];
        }
      }
      return null;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadChannels();
      }
    },
  },
  methods: {
    channelKeyFor(ch) {
      if (ch.id && ch.type === 'usdt_auto') {
        return 'usdt_' + ch.id;
      }
      if (ch.id && ch.type === 'wallet_pay') {
        return 'cp_' + ch.id;
      }
      return ch.gateway || ch.code || String(ch.id);
    },
    loadChannels() {
      const that = this;
      that.$apiFun.get('/api/getAllPaymentMethods', { category: 'hot' }).then(function(res) {
        if (res.code === 200 && res.data && res.data.length) {
          that.channels = res.data.filter(function(item) {
            return item.type === 'wallet_pay' || item.type === 'usdt_auto' || item.gateway === 'epusdt';
          });
          if (!that.channels.length) {
            that.channels = res.data;
          }
        } else {
          that.$apiFun.get('/api/tg/deposit/channels').then(function(r2) {
            if (r2.code === 200 && r2.data) {
              that.channels = r2.data.map(function(c) {
                return {
                  id: c.id,
                  name: c.name,
                  code: c.code || c.gateway,
                  gateway: c.gateway || c.code,
                  min_price: c.min_price || 10,
                  max_price: c.max_price || 100000,
                };
              });
            }
          });
        }
        if (that.channels.length && !that.channelKey) {
          that.channelKey = that.channelKeyFor(that.channels[0]);
        }
      });
    },
    openPayLink(url) {
      if (!url) return;
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.openLink) {
        window.Telegram.WebApp.openLink(url);
      } else {
        window.open(url, '_blank');
      }
    },
    submit() {
      const that = this;
      if (!sessionStorage.getItem('token')) {
        that.$toast('请先登录');
        return;
      }
      const ch = that.selectedChannel;
      if (!ch) {
        that.$toast('请选择支付方式');
        return;
      }
      const amt = parseFloat(that.amount);
      const min = parseFloat(ch.min_price || 10);
      const max = parseFloat(ch.max_price || 100000);
      if (!amt || amt < min || amt > max) {
        that.$toast('金额需在 ' + min + ' ~ ' + max + ' 之间');
        return;
      }
      const payload = { amount: amt };
      if (ch.type === 'usdt_auto' && ch.id) {
        payload.usdt_pay_id = ch.id;
      } else if (ch.id && (ch.type === 'wallet_pay' || ch.data)) {
        payload.code_pay_id = ch.id;
      } else {
        payload.method = ch.gateway || ch.code || 'okpay';
        const gw = ch.gateway || ch.code || '';
        payload.currency = gw.indexOf('cny') >= 0 ? 'CNY' : 'USDT';
      }
      that.loading = true;
      that.$apiFun
        .post('/api/wallet/recharge', payload)
        .then(function(res) {
          that.loading = false;
          const data = res.data || {};
          const link = data.paylink || data.pay_link;
          if (res.code === 200 && link) {
            that.openPayLink(link);
            that.$toast('已打开支付，到账后余额自动增加');
            that.$emit('paid');
          } else {
            that.$toast(res.message || res.msg || '创建订单失败');
          }
        })
        .catch(function() {
          that.loading = false;
          that.$toast('请求失败');
        });
    },
  },
};
</script>

<style scoped>
.tg-deposit {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: #fff;
}
.body {
  padding: 16px;
}
.methods {
  margin: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.hint {
  font-size: 12px;
  color: #888;
  margin: 8px 0;
}
.hint.small {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/tgDeposit.vue